import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import theme from '../theme';
import {
  Alert, Box, Chip, CircularProgress, Divider, Paper, Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import api from '../services/api';
import moment from "moment";
import 'moment/locale/pt-br';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function FormDialogHistory({ info, handlerClose, open }) {
  const [history, setHistory] = React.useState([]);
  const [ppiExecs, setPpiExecs] = React.useState([]);
  const [execLoading, setExecLoading] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      gethistory();
      fetchPpiExecutions();
    }
    if (!open) {
      setHistory([]);
      setPpiExecs([]);
    }
  }, [open, info?.triggerid]);

  const gethistory = () => {
    if (!info?.triggerid) {
      setHistory([]);
      return;
    }
    api.get(`dashboard/history/${info.cod_empresa}/${info.triggerid}/`)
      .then(res => setHistory(res.data))
      .catch(() => setHistory([]));
  };

  const fetchPpiExecutions = () => {
    if (!info?.event_id || !info?.cod_empresa) return;
    setExecLoading(true);
    api.get(`ppi/execution/find/${info.event_id}/${info.cod_empresa}`)
      .then(res => setPpiExecs(res.data || []))
      .catch(() => setPpiExecs([]))
      .finally(() => setExecLoading(false));
  };

  return (
    <Dialog open={open} fullWidth scroll="paper" maxWidth='lg'>
      <DialogTitle>Historico:</DialogTitle>
      <DialogContent>
        {/* PPI Executions */}
        {(ppiExecs.length > 0 || execLoading) && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Execucoes PPI</Typography>
            {execLoading ? (
              <CircularProgress size={20} />
            ) : (
              ppiExecs.map((exec, i) => (
                <Alert
                  key={exec.id || i}
                  severity={exec.completed ? 'success' : 'info'}
                  sx={{ mb: 0.5, py: 0.5 }}
                  icon={false}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    {exec.ppi_description && (
                      <Chip label={exec.ppi_description} size="small" color="primary" variant="outlined" sx={{ height: 20, fontSize: '0.65rem' }} />
                    )}
                    <Typography variant="caption">
                      {exec.user_name} - {new Date(exec.created_at).toLocaleString('pt-BR')}
                    </Typography>
                    <Chip
                      label={exec.completed ? 'Completa' : 'Parcial'}
                      size="small"
                      color={exec.completed ? 'success' : 'warning'}
                      sx={{ height: 18, fontSize: '0.65rem' }}
                    />
                  </Box>
                  {exec.steps_state && Array.isArray(exec.steps_state) && (
                    <Box sx={{ mt: 0.5, pl: 1 }}>
                      {exec.steps_state.map((s, si) => (
                        <Typography key={si} variant="caption" display="block">
                          {s.checked ? '✓' : '○'} {s.title || `Step ${si + 1}`}
                          {s.observation && <span style={{ color: '#666' }}> — {s.observation}</span>}
                        </Typography>
                      ))}
                    </Box>
                  )}
                </Alert>
              ))
            )}
            <Divider sx={{ mt: 1 }} />
          </Box>
        )}

        {/* Zabbix history */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell align="center">Descricao</TableCell>
                <TableCell align="center">Horario</TableCell>
                <TableCell align="center">Vistos</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.length > 0 ? history.map((row, i) => (
                <TableRow
                  key={row.objectid + '' + i}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">{row.name}</TableCell>
                  <TableCell align="right">
                    {moment.unix(row.clock).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell align="right">
                    {row.acknowledges?.map((ack, ai) => (
                      <Alert key={ai} sx={{ mt: 1, backgroundColor: grey[1000] }} severity="info">
                        <Typography>
                          {moment.unix(ack.clock).locale('pt-br').format('DD-MM-YYYY HH:mm:ss')} - Vistado {moment.unix(ack.clock).locale('pt-br').fromNow()}:
                        </Typography>
                        {ack.message}
                      </Alert>
                    ))}
                  </TableCell>
                </TableRow>
              )) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button sx={{ color: theme.palette.text.primary }} onClick={handlerClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
